import { defineComponent as _defineComponent } from 'vue'
import VulnerabilitySeverity from '@/_core/entities/vulnerability/ui/VulnerabilitySeverity/VulnerabilitySeverity.vue';
import type { TComplianceMappingRequirement, TComplianceMappingItem } from '@/_core/entities/report/models/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ComplianceMappingRow',
  props: {
    requirement: null,
    expanded: { type: Boolean }
  },
  emits: ["toggle"],
  setup(__props: any) {





const ROLE_ORDER = ['primary', 'secondary', 'universal'];

const ROLE_CONFIG: Record<string, { label: string; severityKey: string; badgeClass: string; tooltip: string }> = {
  primary: {
    label: 'Primary',
    severityKey: 'primary',
    badgeClass: 'tw:bg-[#FDC7C0] tw:border-[#FB7462]/40 tw:text-[#FB7462]',
    tooltip: 'This item directly reflects the main cause of the vulnerability',
  },
  secondary: {
    label: 'Secondary',
    severityKey: 'secondary',
    badgeClass: 'tw:bg-[#FFE1C6] tw:border-[#FF7A08]/40 tw:text-[#FF7A08]',
    tooltip: 'This item adds broader context or supporting controls related to the vulnerability',
  },
  universal: {
    label: 'Supporting',
    severityKey: 'supporting',
    badgeClass: 'tw:bg-[#DFEBFF] tw:border-[#3180F6]/40 tw:text-[#3180F6]',
    tooltip: 'This item is relevant to the vulnerability, but less directly',
  },
};

function sortedRoles(roles: string[]) {
  return [...roles].sort((a, b) => ROLE_ORDER.indexOf(a) - ROLE_ORDER.indexOf(b));
}

function cfg(role: string) {
  return ROLE_CONFIG[role] || ROLE_CONFIG.universal;
}

const ROW_GRID = 'tw:grid-cols-[1.5rem_minmax(10rem,1fr)_minmax(16rem,24rem)] tw:max-[500px]:grid-cols-[1fr]';

const TREE_LINE =
  'tw:relative tw:max-[500px]:before:hidden tw:max-[500px]:after:hidden ' +
  "tw:before:content-[''] tw:before:absolute tw:before:left-[36px] tw:before:top-0 tw:before:bottom-0 tw:before:w-px tw:before:bg-[#e4e8ee] " +
  "tw:after:content-[''] tw:after:absolute tw:after:left-[36px] tw:after:top-1/2 tw:after:w-4 tw:after:h-px tw:after:bg-[#e4e8ee]";

const TREE_LINE_LAST =
  'tw:before:!bottom-1/2 tw:before:!w-4 tw:before:!bg-transparent tw:before:border-l tw:before:border-b tw:before:border-[#e4e8ee] tw:before:rounded-bl-[10px] tw:after:hidden';

return { __sfc: true,ROLE_ORDER, ROLE_CONFIG, sortedRoles, cfg, ROW_GRID, TREE_LINE, TREE_LINE_LAST, VulnerabilitySeverity }
}

})